import { v4 } from 'uuid';

import { type RenderOptions, render } from './request';

import { createCache } from '../../cache/cache';

import type { Echo, EchoSnapshot, EchoView } from '../types';

export const previewCache = createCache<string, EchoView>(10);

/**
 * Fetch the URL. If the server returns an `EchoView`, we'll store it in the cache for later.
 */
export async function revalidate(options: RenderOptions): Promise<Echo> {
  const echo = await render(options);

  if (echo.type === 'view') {
    previewCache.set(options.url, echo);
  }

  return echo;
}

/**
 * If the URL exists in the cache, we'll return a cached response. The `isPreview` field
 * indicates that revalidation is necessary.
 *
 * Otherwise, we'll fetch a fresh response from the server.
 */
export async function renderSnapshot({ url, signal }: RenderOptions): Promise<EchoSnapshot> {
  const preview = previewCache.get(url);

  if (preview) {
    return { url, echo: preview, isPreview: true, id: v4() };
  }

  const echo = await revalidate({ url, signal });
  return { url, echo, isPreview: false, id: v4() };
}
